import { Link as ReactRouterLink } from "react-router-dom";
import {
  Box,
  Center,
  Flex,
  Grid,
  GridItem,
  Image,
  useBreakpointValue
} from "@chakra-ui/react";
import { Link as ChakraLink } from '@chakra-ui/react'

import Qrcode from "@/assets/images/contant_qrcode.jpg";

const Footer = () => {

  // 使用断点来决定在不同屏幕尺寸下GridItem应该占据的列数
  const gridTemplateColumns = useBreakpointValue({
    base: 'repeat(1, 1fr)', // 手机屏幕，每个Item占据全部宽度
    md: 'repeat(3, 1fr)', // 平板屏幕，每个Item占据33.3%宽度
    lg: 'repeat(3, 1fr)', // 桌面屏幕，每个Item占据33.3%宽度
  });
  
  return (
    <Box>
      <Box
        sx={{
          bg: "#000",
          fontSize: "12px",
          pb: "10px",
          color: "#fff"
        }}
      >
        <Center
          sx={{
            maxW: "84%",
            margin: "0 auto",
          }}
        >
          <Grid  templateColumns={gridTemplateColumns} gap={6}>
            <GridItem colSpan={1}>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  paddingBottom: "5px",
                  marginTop: "10px",
                  borderBottom: "1px solid #696E74",
                }}
              >
                网站导航
              </Box>
              <Flex gap={10}>
                <Box>
                  <Flex flexDirection="column" gap={1}>
                    <ReactRouterLink to="/">首页</ReactRouterLink>
                    <ReactRouterLink to="">发现</ReactRouterLink>
                    <ReactRouterLink to="">AI生图</ReactRouterLink>
                    <ReactRouterLink to="">AI生文</ReactRouterLink>
                  </Flex>
                </Box>
                <Box>
                  <Flex flexDirection="column" gap={1}>
                    <ReactRouterLink to="">设计实验室</ReactRouterLink>
                    <ReactRouterLink to="">关于我们</ReactRouterLink>
                    <ReactRouterLink to="">企业/学校</ReactRouterLink>
                  </Flex>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  paddingBottom: "5px",
                  marginTop: "10px",
                  borderBottom: "1px solid #696E74",
                }}
              >
                联系我们
              </Box>
              <Box>邮箱：biz@art1001.com</Box>
              <Box>电话：400-064-1001</Box>
              <Box>
                地址：北京市石景山区和平西路55号院2号楼金安中海财富中心B座4层407-408.
              </Box>
            </GridItem>
            <GridItem colSpan={1}>
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  paddingBottom: "5px",
                  marginTop: "10px",
                  borderBottom: "1px solid #696E74",
                }}
              >
                关注我们
              </Box>
              <Image
                boxSize="120px"
                objectFit="contain"
                src={Qrcode}
                alt="关注我们"
              />
            </GridItem>
          </Grid>
        </Center>
      </Box>
      <Box
        minH="32px"
        bg="#616161"
        fontSize="12px"
        sx={{
          lineHeight: "20px",
          p: "6px",
          color: "#fff"
        }}
      >
        <Box
          sx={{
            maxW: "84%",
            margin: "0 auto",
            textAlign: "center"
          }}
        >
          Copyright © 2015 -2024 壹仟零壹艺数智（北京）科技有限公司，保留所有权利， <ChakraLink href="https://beian.miit.gov.cn/" target="_blank">京ICP备15048668号-6</ChakraLink>
          {/* <Center>
            Copyright © 2015-2024 Art1001 Network Technology(Beijing) Co. Ltd. All Rights reserved
          </Center> */}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
